import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/sofax/google-icon.svg")